<template>
  <div id="inventarios-productos">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-widget title="INVENTARIO PRODUCTOS" color="primary darken-4" dark>
            <div slot="widget-content">
              <v-layout wrap class="container">
                <v-flex xs12 sm6>
                  <v-select
                    v-model="sucursalSeleccionada"
                    :items="sucursalesUsuario"
                    item-text="nombreSucursal"
                    item-value="sucursalId"
                    label="Selecciona una sucursal"
                    solo
                    return-object
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex lg12>
                  <v-card>
                    <v-toolbar card color="white">
                      <v-text-field
                        flat
                        solo
                        prepend-icon="search"
                        placeholder="Búsqueda rápida"
                        v-model="search"
                        hide-details
                        class="hidden-sm-and-down"
                      ></v-text-field>
                      <v-btn icon>
                        <v-icon>filter_list</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">
                      <v-data-table
                        :headers="headers"
                        :search="search"
                        :items="inventariosProductos"
                        :rows-per-page-items="[
                          25,
                          50,
                          100,
                          { text: 'Todos', value: -1 },
                        ]"
                        class="elevation-1"
                        item-key="clienteId"
                      >
                        <template slot="items" slot-scope="props">
                          <!-- <td>
                            <v-avatar size="48">
                              <v-icon color="primary" medium>list_alt</v-icon>
                            </v-avatar>
                          </td>-->
                          <td>{{ props.item.sku }}</td>
                          <td>{{ props.item.descripcionProducto }}</td>
                          <td>{{ props.item.descripcionTalla }}</td>
                          <td>
                            <v-icon :color="props.item.codigoHtml" medium
                              >widgets</v-icon
                            >
                            {{ props.item.nombreColor }}
                          </td>
                          <td>
                            <v-text-field
                              label="Disponible venta"
                              v-model="props.item.cantidadVenta"
                              type="number"
                              :rules="[
                                () =>
                                  props.item.cantidadVenta >= 0 ||
                                  'No puede ser negativo!',
                              ]"
                              @change="updateInventario(props.item)"
                              @input="updateInventario(props.item)"
                            ></v-text-field>
                          </td>
                          <td>
                            <v-text-field
                              label="Disponible renta"
                              v-model="props.item.cantidadRenta"
                              type="number"
                              :rules="[
                                () =>
                                  props.item.cantidadRenta >= 0 ||
                                  'No puede ser negativo!',
                              ]"
                              @change="updateInventario(props.item)"
                              @input="updateInventario(props.item)"
                            ></v-text-field>
                          </td>
                          <td>
                            <v-btn
                              color="info"
                              flat
                              @click="getRentasByCatalogo(props.item)"
                              >{{ props.item.cantidadRentada }}</v-btn
                            >
                          </td>
                          <td>{{ props.item.cantidadTintoreria }}</td>
                          <td>
                            <v-btn
                              depressed
                              outline
                              icon
                              fab
                              dark
                              color="pink"
                              small
                              @click="
                                deleteInventario(props.item.catalogoRowId)
                              "
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </td>
                        </template>
                        <v-alert
                          slot="no-results"
                          :value="true"
                          color="error"
                          icon="warning"
                          outline
                          >La búsqueda para "{{ search }}" no encontró
                          registros</v-alert
                        >
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </div>
          </v-widget>
        </v-flex>
      </v-layout>
      <v-alert
        :value="$store.state.operationFailed"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-container>

    <v-dialog v-model="showDialog" persistent max-width="1300px">
      <v-card>
        <v-toolbar color="primary darken-4" dark>
          <img :src="$store.state.iconoForm" height="42" />
          <v-toolbar-title class="ml-0 pl-3">
            <span class="hidden-sm-and-down">{{
              $store.state.tituloForm
            }}</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="showDialog = false">
            <v-icon danger>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-md>
            <rentas-catalogo
              ref="rentasCatalogo"
              :sucursal="sucursalSeleccionada"
            ></rentas-catalogo>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed @click.native="showDialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <confirm ref="confirm"></confirm>

    <snack-bar></snack-bar>

    <loading-alert></loading-alert>
  </div>
</template>

<script>
import VWidget from "@/components/VWidget";
import confirm from "@/components/dialogs/Confirm";
import loadingAlert from "@/components/LoadingAlert";
import snackBar from "@/components/SnackBar";

//Local components
import rentasCatalogo from "@/views/rentas/GridRentasByCatalogo";

import inventarioProductoService from "@/services/inventarioProductoService";

export default {
  components: {
    VWidget,
    confirm,
    loadingAlert,
    snackBar,
    rentasCatalogo,
  },
  data() {
    return {
      search: "",
      headers: [
        // { text: "", align: "center", sortable: false },
        {
          text: "SKU",
          align: "center",
          value: "sku",
        },
        { text: "PRODUCTO", align: "center", value: "descripcionProducto" },
        { text: "TALLA", align: "center", value: "descripcionTalla" },
        { text: "COLOR", align: "center", value: "nombreColor" },
        { text: "DISPONIBLE VENTA", align: "center", value: "cantidadVenta" },
        { text: "DISPONIBLE RENTA", align: "center", value: "cantidadRenta" },
        { text: "RENTADOS", align: "center", value: "cantidadRentada" },
        { text: "EN TINTORERIA", align: "center", value: "cantidadTintoreria" },
        { text: "ACCIONES", value: "acciones", align: "right" },
      ],
      sucursalesUsuario: [],
      sucursalSeleccionada: {
        sucursalId: 0,
        nombreSucursal: "",
      },
      inventariosProductos: [],
      showDialog: false,
    };
  },
  watch: {
    sucursalSeleccionada: function (n) {
      this.getInventariosProductos(n.sucursalId);
    },
  },
  mounted() {
    let self = this;
    try {
      let current_user = this.$store.state.currentUser;
      this.sucursalesUsuario = current_user.sucursales;
      if (this.sucursalesUsuario.length > 0) {
        this.sucursalSeleccionada = this.sucursalesUsuario[0];
      }
    } catch (e) {
      self.codeFailed(
        "Ocurrió un error al extraer sucursales, es posible que se haya perdido la sesión o no tengas sucursales asignadas"
      );
    }
  },
  methods: {
    getInventariosProductos(sucursalId) {
      let self = this;
      self.$store.state.loadingInfo.show = true;
      inventarioProductoService
        .getAllBySucursal(sucursalId)
        .then((result) => {
          self.inventariosProductos = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    updateInventario(inventario) {
      let self = this;
      inventarioProductoService
        .update(inventario)
        .then((result) => {
          self.$store.state.snackbar.color = "success";
          self.$store.state.snackbar.text = "Precios actualizados";
          self.$store.state.snackbar.visible = true;
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        });
    },
    deleteInventario() {},
    getRentasByCatalogo(catalogoRow) {
      let self = this;
      if (catalogoRow.cantidadRentada > 0) {
        self.$store.state.tituloForm =
          "RENTAS QUE TIENEN EL PRODUCTO " + catalogoRow.sku;
        self.$store.state.iconoForm = "/images/general/agregar-40.png";

        self.$refs.rentasCatalogo.getRentas(catalogoRow.catalogoRowId);
        self.showDialog = true;
      }
    },
  },
};
</script>
